import { inject } from '@angular/core';
import { StorageService } from './StorageService';
import { StorageSQLiteService } from './StorageSQLiteService';
import { PlatformStrategyService } from '../services/platform.strategy.service';

// useFactory runs inside Angular's injection context, so the classes'
// inject() field initializers resolve correctly when constructed here.
const storageOfflineServiceFactory = () => {
  const platformStrategy = inject(PlatformStrategyService);
  return platformStrategy.isMobile()
    ? new StorageSQLiteService()
    : new StorageService();
};

// Utilizar este provider en el modulo principal (app.module o main.ts)
// puesto que el service debe ser la misma instancia en toda la app
export const storageOfflineServiceProvider = {
  provide: StorageService,
  useFactory: storageOfflineServiceFactory,
};
